module.exports = __webpack_public_path__ + "static/lightship-vps-for-web-98fbec85b0c18ce1272dc17db2cf913c.jpg";